module.exports = __webpack_public_path__ + "img/hr-H-T-2-unload-connect-shadow.e45fb1e1.png";